const studentInvoiceResult = {
  path: 'studentInvoiceResult',
  component: resolve => require(['../../../../components/pages/signUp/studentInvoiceResult'], resolve)
}
export default studentInvoiceResult
